export default {"src":"/_next/static/media/feature1_mobile.6b98aad9.svg","height":483,"width":430,"blurWidth":0,"blurHeight":0};